import {createContext, useContext} from 'react';
import {TrackingContext} from '@homeaway/react-event-tracking';

export const MapContext = createContext({appName: 'react-map-components'});

export const useMapContext = () => useContext(MapContext);

export const useTrackingContext = () => useContext(TrackingContext);

export default MapContext;
